<template>
  <v-container v-if="!containerInitLoading && partnerCompany" fluid style="height: inherit">
    <v-row align="stretch" style="height: inherit;">
      <v-col :cols="isPhoneBool ? 12 : 6">
        <EntityEditCard :title="$t('servicesystem.common_objects.commonterms.details')" :item="partnerCompany"
          :saveMethod="saveChanges">
          <template v-slot:content="{ item, editMode, handleFocus }">
            <PartnerCompanyEditContent :editItem="item" :editMode="editMode" :handleFocus="handleFocus">
            </PartnerCompanyEditContent>
          </template>
        </EntityEditCard>
      </v-col>

      <v-col :cols="isPhoneBool ? 12 : 6" style="background-color: rgb(248, 248, 248) !important;">
        <v-row no-gutters>
          <v-col cols="12">
            <EntityEditCard :title="$t('servicesystem.common_objects.commonterms.address')" :item="partnerCompany"
              :saveMethod="saveChanges">
              <template v-slot:content="{ item, editMode, handleFocus }">
                <PartnerCompanyAddressEditContent :editItem="item" :editMode="editMode" :handleFocus="handleFocus">
                </PartnerCompanyAddressEditContent>
              </template>
            </EntityEditCard>
          </v-col>
        </v-row>
        <v-divider class="my-4"></v-divider>
        <v-row no-gutters>
          <v-col cols="12">
            <EntityEditCard :title="$t('servicesystem.common_objects.partner_company.manager')" :item="partnerCompany"
              :saveMethod="saveChanges">
              <template v-slot:content="{ item, editMode, handleFocus }">
                <PartnerCompanyContactEditContent :editItem="item" :editMode="editMode" :handleFocus="handleFocus">
                </PartnerCompanyContactEditContent>
              </template>
            </EntityEditCard>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import EntityEditCard from "@/views/layouts/EntityEditCard.vue";
import PartnerCompanyEditContent from "@/views/admin/partnercompany/PartnerCompanyEditContent.vue";
import PartnerCompanyAddressEditContent from "@/views/admin/partnercompany/PartnerCompanyAddressEditContent.vue";
import PartnerCompanyContactEditContent from "@/views/admin/partnercompany/PartnerCompanyContactEditContent.vue";

export default {
  name: "PartnerCompanyInfo",
  props: {
    containerInitLoading: Boolean, //getting container data for the first time, show skeletonloader
    containerLoading: Boolean, //loading container data update, do so in the background with small indicator
    containerItem: Object, //container data
  },
  components: {
    EntityEditCard,
    PartnerCompanyEditContent,
    PartnerCompanyAddressEditContent,
    PartnerCompanyContactEditContent,
  },
  mixins: [clientAPI],

  data() {
    return {
    };
  },

  mounted() { },

  methods: {
    async saveChanges(obj) {
      const dto = Object.assign({}, obj);
      await this.changePartnerCompany(dto)
        .then((response) => {
          this.partnerCompany = response;
        })
        .catch((exception) => {
          console.error(exception);
        });
    },
  },

  computed: {
    partnerCompany: {
      get() {
        return this.containerItem;
      },
      set(value) {
        this.$emit('SetContainerItem', value);
      }
    },
  },

  watch: {},
};
</script>


<style lang='scss'></style>